import React from "react";
import { AppAuthenticatedContext } from "../../providers/AppAuthenticatedProvider";

/**
 * Same context as {@link useAuthenticated}, but for components that also
 * render on guest/public pages (no `AppAuthenticatedContext.Provider`
 * ancestor) — returns `undefined` there instead of throwing.
 */
export function useAuthenticatedOptional() {
  return React.useContext(AppAuthenticatedContext);
}
